import React, { useEffect, useState } from "react";
import "./ExternalNoPageFound.css";
import logo from "../../../Assests/RebelSkool.png";
import { useHistory } from "react-router-dom";

import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";

const ExternalNoPageFound = () => {
  const [showCountdown, setShowCountdown] = useState(true);
  const [countdown, setCountdown] = useState(4);
  const history = useHistory();
  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          history.push("/external/login");
          setShowCountdown(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const headercomponent = () => {
    return (
      <div className=" ExternalNoPageFound-header-logo">
        <img
          src={logo}
          alt="Logo"
          className="ExternalNoPageFound-header-logo"
        />
      </div>
    );
  };
  return (
    <div className="ExternalNoPageFound-Main-Div">
      <>
        {showCountdown && (
          <Dialog
            className="card"
            visible={showCountdown}
            modal={true}
            style={{ width: "30vw" }}
            header={headercomponent()}
            closable={false}
            maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.7)" }}
          >
            <Card className="ExternalNoPageFound-Dialog-card">
              <center>
                <i
                  className="pi  pi-spinner pi-spin"
                  style={{ fontSize: "2rem" }}
                ></i>
                <div style={{ marginTop: "1rem" }}>
                  <h4 className="ExternalNoPageFound-Dialog-header">
                    Page Not Found
                  </h4>
                  <p className="ExternalNoPageFound-countdown">
                    Redirecting to External Page in {countdown} seconds...
                  </p>
                </div>
              </center>
            </Card>
          </Dialog>
        )}
      </>
    </div>
  );
};
export default ExternalNoPageFound;
